import { createFileRoute } from "@tanstack/react-router";

import { AgentStatus } from "@/features/agent/AgentStatus";

export const Route = createFileRoute("/agent/status")({
  component: AgentStatus,
});
